// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css-emotion/src/Css.bs.js");
var CssJs = require("bs-css-emotion/src/CssJs.bs.js");
var Js_array = require("@rescript/std/lib/js/js_array.js");
var Util_Css = require("../util/Util_Css.bs.js");
var Util_Dom = require("../util/Util_Dom.bs.js");
var Belt_Array = require("@rescript/std/lib/js/belt_Array.js");
var Caml_option = require("@rescript/std/lib/js/caml_option.js");
var Type_Header = require("../type/Type_Header.bs.js");
var Particle_Css = require("./particle/Particle_Css.bs.js");
var Particle_Color = require("./particle/Particle_Color.bs.js");
var Layout_Constants = require("./layout/Layout_Constants.bs.js");
var Particle_Screen_Ds = require("./particle/Particle_Screen_Ds.bs.js");
var Particle_Screen_Css = require("./particle/Particle_Screen_Css.bs.js");
var Particle_Background_Ds = require("./particle/Particle_Background_Ds.bs.js");
var Particle_Background_Css = require("./particle/Particle_Background_Css.bs.js");

function injectFonts(param) {
  [
    CssJs.fontFace("barna", [
          CssJs.url("//static-cdn.arte.tv/static/fonts/barna-web/woff2/Barna-Light.woff2"),
          CssJs.url("//static-cdn.arte.tv/static/fonts/barna-web/woff/Barna-Light.woff")
        ], Css.normal, Css.thin, "swap", undefined),
    CssJs.fontFace("barna", [
          CssJs.url("//static-cdn.arte.tv/static/fonts/barna-web/woff2/Barna-Regular.woff2"),
          CssJs.url("//static-cdn.arte.tv/static/fonts/barna-web/woff/Barna-Regular.woff")
        ], Css.normal, Css.normal, "swap", undefined),
    CssJs.fontFace("barna", [
          CssJs.url("//static-cdn.arte.tv/static/fonts/barna-web/woff2/Barna-SemiBold.woff2"),
          CssJs.url("//static-cdn.arte.tv/static/fonts/barna-web/woff/Barna-SemiBold.woff")
        ], Css.normal, Css.semiBold, "swap", undefined),
    CssJs.fontFace("barna", [
          CssJs.url("//static-cdn.arte.tv/static/fonts/barna-web/woff2/Barna-Bold.woff2"),
          CssJs.url("//static-cdn.arte.tv/static/fonts/barna-web/woff/Barna-Bold.woff")
        ], Css.normal, Css.bold, "swap", undefined)
  ];
}

var selector = [
  "a",
  "abbr",
  "acronym",
  "address",
  "applet",
  "article",
  "aside",
  "audio",
  "b",
  "big",
  "blockquote",
  "body",
  "button",
  "canvas",
  "caption",
  "center",
  "cite",
  "code",
  "dd",
  "del",
  "details",
  "dfn",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "header",
  "hgroup",
  "i",
  "iframe",
  "ins",
  "kbd",
  "label",
  "legend",
  "li",
  "mark",
  "menu",
  "nav",
  "object",
  "ol",
  "output",
  "p",
  "pre",
  "q",
  "ruby",
  "s",
  "samp",
  "section",
  "small",
  "span",
  "strike",
  "strong",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "time",
  "tr",
  "tt",
  "u",
  "ul",
  "var",
  "video"
];

var common_1 = [
  CssJs.margin(CssJs.zero),
  CssJs.padding(CssJs.zero),
  CssJs.fontSize(CssJs.pct(100)),
  CssJs.verticalAlign(CssJs.baseline),
  CssJs.unsafe("border", "0")
];

var common = [
  selector,
  common_1
];

var list_0 = [
  "ul",
  "ol"
];

var list_1 = [CssJs.listStyleType(CssJs.none)];

var list = [
  list_0,
  list_1
];

function injectGlobal(param) {
  CssJs.$$global(Js_array.joinWith(",", param[0]), param[1]);
}

var img_0 = ["img"];

var img_1 = [CssJs.maxWidth(CssJs.pct(100))];

var img = [
  img_0,
  img_1
];

var all_0 = ["*"];

var all_1 = [CssJs.outlineStyle("none")];

var all = [
  all_0,
  all_1
];

var link_0 = [
  "a",
  "a:hover",
  "a:focus"
];

var link_1 = [CssJs.textDecoration("none")];

var link = [
  link_0,
  link_1
];

var button_0 = ["a, button, input, select, textarea"];

var button_1 = [
  CssJs.outline(CssJs.px(2), CssJs.solid, CssJs.transparent),
  CssJs.outlineOffset(CssJs.px(0))
];

var button = [
  button_0,
  button_1
];

var reset = [
  all,
  common,
  list,
  link,
  img,
  button
];

function run(param) {
  Belt_Array.forEach(reset, injectGlobal);
}

var Reset = {
  common: common,
  list: list,
  injectGlobal: injectGlobal,
  img: img,
  all: all,
  link: link,
  button: button,
  reset: reset,
  run: run
};

function useTheme(theme) {
  var $$document = Util_Dom.SafeWebApi.$$document;
  if ($$document === undefined) {
    return ;
  }
  var html = Caml_option.valFromOption($$document).querySelector("html");
  var className = Particle_Color.Var.getThemeClassName(theme);
  if (!(html == null)) {
    html.className = className;
    return ;
  }
  
}

function useDarkTheme(param) {
  useTheme("Dark");
}

function injectTheme(theme) {
  var className = Particle_Color.Var.getThemeClassName(theme);
  var rules = Particle_Color.Css.varColorsToCss(Particle_Color.Var.getThemeVariables(theme));
  CssJs.$$global("html." + className + "", rules);
}

function initTheme(theme) {
  var rules = Particle_Color.Css.varColorsToCss(Particle_Color.Var.getThemeVariables(theme));
  CssJs.$$global(":root", rules);
}

function make(withFont, theme, withHeaderPadding, param) {
  if (withFont) {
    injectFonts(undefined);
  }
  Belt_Array.forEach(reset, injectGlobal);
  CssJs.$$global("html", Belt_Array.concatMany([
            [
              CssJs.boxSizing(CssJs.borderBox),
              Particle_Css.baseFontSize,
              CssJs.display("flex"),
              CssJs.justifyContent(CssJs.center),
              CssJs.unsafe("scrollBehavior", "smooth")
            ],
            Particle_Background_Css.toCss(Particle_Background_Ds.background)
          ]));
  CssJs.$$global("body", Belt_Array.concat([
            CssJs.width(CssJs.pct(100)),
            CssJs.maxWidth(Layout_Constants.maxWidthMainContent),
            CssJs.margin4(Css.px(0), Css.auto, Css.px(0), Css.auto),
            CssJs.display("flex"),
            CssJs.alignContent("center"),
            CssJs.overflowX("hidden"),
            CssJs.flexDirection("column"),
            CssJs.unsafe("WebkitFontSmoothing", "antialiased"),
            CssJs.unsafe("MozOsxFontSmoothing", "grayscale")
          ], withHeaderPadding ? Particle_Screen_Css.toRules(undefined, undefined, (function (param) {
                    return Util_Css.toRules(CssJs.paddingTop, param);
                  }), Particle_Screen_Ds.make(undefined, undefined, Particle_Css.pxToRem(Type_Header.Constants.height.m), undefined, undefined, Particle_Css.pxToRem(Type_Header.Constants.height.default))) : []));
  CssJs.$$global("*, ::after, ::before", [CssJs.boxSizing(CssJs.inherit_)]);
  CssJs.$$global("::placeholder", [Particle_Css.baseFontSize]);
  CssJs.$$global("input[type=\"search\"]::-webkit-search-decoration,::-webkit-search-cancel-button,\n  ::-webkit-search-results-button,::-webkit-search-results-decoration", [CssJs.display("none")]);
  injectTheme("Dark");
  injectTheme("Light");
  initTheme(theme);
}

function make$1(withFont, param) {
  if (withFont) {
    injectFonts(undefined);
  }
  injectGlobal(button);
}

var Mona = {
  make: make$1
};

exports.injectFonts = injectFonts;
exports.Reset = Reset;
exports.useTheme = useTheme;
exports.useDarkTheme = useDarkTheme;
exports.injectTheme = injectTheme;
exports.initTheme = initTheme;
exports.make = make;
exports.Mona = Mona;
/* common Not a pure module */
